import React from 'react';
import { Tooltip, Icon, Link } from '@chakra-ui/react';
import { InfoOutlineIcon } from '@chakra-ui/icons';

export default function HelpTooltip({ label, href }) {
  const content = (
    <div>
      <div style={{ marginBottom: href ? 8 : 0 }}>{label}</div>
      {href && (
        <Link href={href} isExternal color="blue.500" textDecoration="underline">
          Learn more
        </Link>
      )}
    </div>
  );
  return (
    <Tooltip label={content} hasArrow placement="right" openDelay={300}>
      <span>
        <Icon as={InfoOutlineIcon} color="gray.400" _hover={{ color: 'blue.500' }} cursor="help" ml={2} />
      </span>
    </Tooltip>
  );
}


